import React from 'react';
import styled from 'styled-components'
import { SuggestionBoxEntryColor } from "../../Constants/ColorChart";

/*
 *  @Description:   Stateless component that renders a hint and one or more SuggestionItem.
 *                  The hint should be passed by props. The SuggestionItems should be passed by props.children.
 */

const StyledP = styled.p`
    color: ${ SuggestionBoxEntryColor };
    display: block;
    font-size: 14px;
    padding-right: 10px;
    display: block;
    font-weight: bold;
`;

const StyledDiv = styled.div`
	display: block;
    text-align: left;
	margin-left: auto;
    margin-right: auto;
    padding: 20px 5px 0 5px;
`;

const FilterBox = (props) => {
    return (
        <StyledDiv id="filters">
            { props.hint &&
            <StyledP>{ props.hint }</StyledP>
            }
            { props.children.map( child => (child) ) }
        </StyledDiv>
    );
}

export default FilterBox;

